import * as angular from "angular"

export const queryModule = angular.module("queryModule", [
    "ui.router",
    "nlgScriptSqlQueryReportModule"
])